import React, { useEffect, useState } from "react"
import { Button, Card, Collapse, CardBody, CardText, CardTitle, Col, Row, Spinner, CardHeader } from "reactstrap"

import { useWallet } from "../../../libs/useMetaMaskWallet"
import Web3 from "web3"

import { formatNumber } from "../../../utils"

const SummaryPrestaking = ({ pool, active, onExpand, handleStakedAmount }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [yourStakeAmount, setYourStakeAmount] = useState(0)
    const [contractDetails, setContractDetails] = useState({ name: "Idexo L3 Node Prestaking", symbol: "ILNP", totalSupply: 0 })
    const [idoBalance, setIdoBalance] = useState(0)
    const [totalStaked, setTotalStaked] = useState(0)
    const [yourNodes, setYourNodes] = useState(0)
    const [currentPrice, setCurrentPrice] = useState(35000)

    const wallet = useWallet()
    const linkToPool = `/nodeprestaking/?pool=${pool.poolSymbol}`

    useEffect(() => {
        ;(async () => {
            if (updateConnection() && wallet.account) {
                setIsLoading(true)
                try {
                    let provider = new Web3(pool.providerUri)
                    let tokenContract = new provider.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
                    let stakingContract = new provider.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
                    let stakingContractName = await stakingContract.methods.name().call()
                    let stakingSymbol = await stakingContract.methods.symbol().call()
                    let urStakeAmount = await stakingContract.methods.balanceOf(wallet.account).call()
                    let balance = await tokenContract.methods.balanceOf(wallet.account).call()
                    setYourNodes(urStakeAmount)
                    let stakedBalance = await tokenContract.methods.balanceOf(pool.stakingContractAddress).call()
                    setContractDetails({
                        name: stakingContractName,
                        symbol: stakingSymbol
                    })
                    setYourStakeAmount(provider.utils.fromWei(urStakeAmount, "ether"))
                    setIdoBalance(provider.utils.fromWei(balance, "ether"))
                    setTotalStaked(formatNumber(parseInt(provider.utils.fromWei(stakedBalance, "ether")).toFixed(0)))
                    handleStakedAmount(pool.poolSymbol, provider.utils.fromWei(stakedBalance, "ether"))
                } catch (err) {
                    console.log(err)
                }
                setIsLoading(false)
            }
        })()
    }, [wallet])

    const updateConnection = () => {
        const x = wallet.status === "connected"
        setIsConnectedToWallet(x)
        return x
    }

    const Loading = () => {
        return <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
    }

    return (
        <React.Fragment>
            <Card className="stake-pool">
                <div>
                    <CardHeader
                        id="pool-header"
                        onClick={(e) => {
                            window.scrollTo({ behavior: "smooth", top: e.clientY + 100 })
                            onExpand(pool.poolSymbol)
                        }}
                    >
                        {!isLoading ? (
                            <div>
                                <div className="info">{pool ? pool.chainSymbol : "Loading"}</div>
                                <div className="symbol">{pool ? pool.poolSymbol : "Loading"}</div>
                            </div>
                        ) : (
                            <div></div>
                        )}

                        <div className="info">{isLoading ? <div></div> : pool ? pool.poolName : "..."}</div>
                        <div className="info">{isLoading ? <div></div> : yourNodes}</div>
                        <div className="info">{isLoading ? <div></div> : currentPrice}</div>
                    </CardHeader>

                    <Collapse isOpen={active === pool.poolSymbol}>
                        <CardBody>
                            <div className="pool-body">
                                <Row>
                                    <Card>
                                        <CardBody>
                                            <CardTitle className="h3">{pool ? pool.poolSymbol : null} Pool Details</CardTitle>

                                            <Row className="contract-details mt-md-4 mb-md-4">
                                                <Col md={4} className="mt-3 mt-md-0">
                                                    <CardText className="card-text-label text-uppercase mb-1">Total Staked </CardText>
                                                    <div className="card-text-value">{isLoading ? <Loading /> : totalStaked}</div>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-0">
                                                    <CardText className="card-text-label text-uppercase mb-1">Your Nodes </CardText>
                                                    <div className="card-text-value">{isLoading ? <Loading /> : formatNumber(yourNodes)}</div>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-0">
                                                    <a href={linkToPool}>
                                                        <Button>View More</Button>
                                                    </a>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Row>
                            </div>
                        </CardBody>
                    </Collapse>
                </div>
            </Card>
        </React.Fragment>
    )
}

export default SummaryPrestaking
